export default "__VITE_ASSET__e1$Yp6K6__"